import React from 'react';
import BrandExposureHeader from '../BrandExposureHeader';
import BrandExposureList from '../BrandExposureList';
import BrandExposureSelectorSection from '../BrandExposureSelectorSection';
import './BrandExposureWrap.scss';

const BrandExposureWrap = (props) => {
  const {
    // 데이터
    brandExposureList,
    brandExposureSelector,
    pageType,
    // reducer의 데이터 수정
    setData,
    // 헤더에서 쓰이는 메소드들
    editBrandExposureListRequest,
    resetBrandExposureInfo,
    // 리스트에서 쓰이는 메소드들
    scrollToBrandElement,
    changeExposureStatus,
    changeNumberOnDragEnd,
    changeNumberOnBrandTierList,
    deleteBrandExposureItem,
    // 셀렉터에서 쓰이는 메소드들
    searchBrandExposureSelectorList,
    resetBrandExposureSelectorList,
    addBrandExposureListItem,
    selectSelectorItem,
    checkIsDuplicateOnExposureList,
    addSelectedItemToList,
  } = props;

  return (
    <div className="brand-exposure-wrap">
      {/*브랜드 노출 헤더*/}
      <BrandExposureHeader
        brandExposureList={brandExposureList}
        pageType={pageType}
        setData={setData}
        editBrandExposureListRequest={editBrandExposureListRequest}
        resetBrandExposureInfo={resetBrandExposureInfo}
      />

      {/*브랜드 노출 본문 영역*/}
      <div className="brand-exposure-content">
        {/*브랜드 노출 리스트*/}
        <BrandExposureList
          brandExposureList={{
            newList: brandExposureList.newList,
          }}
          setData={setData}
          scrollToBrandElement={scrollToBrandElement}
          changeExposureStatus={changeExposureStatus}
          changeNumberOnDragEnd={changeNumberOnDragEnd}
          changeNumberOnBrandTierList={changeNumberOnBrandTierList}
          deleteBrandExposureItem={deleteBrandExposureItem}
        />

        {/*브랜드 셀렉터*/}
        <BrandExposureSelectorSection
          brandExposureList={brandExposureList}
          brandExposureSelector={brandExposureSelector}
          setData={setData}
          searchBrandExposureSelectorList={searchBrandExposureSelectorList}
          resetBrandExposureSelectorList={resetBrandExposureSelectorList}
          addBrandExposureListItem={addBrandExposureListItem}
          selectSelectorItem={selectSelectorItem}
          checkIsDuplicateOnExposureList={checkIsDuplicateOnExposureList}
          addSelectedItemToList={addSelectedItemToList}
        />
      </div>
    </div>
  );
};

export default BrandExposureWrap;
